module.exports = __webpack_public_path__ + "img/02.4cbffb2b.gif";